import { FuseNavigation } from '@fuse/types';

export const navigation: FuseNavigation[] = [

    {
        id: 'inicio',
        title: 'Início',
        type: 'item',
        icon: 'home',
        url: '/a2w/inicio',
        menuPai: 'inicio',
        companySystemModuleItemId: 1
    },
    {
        id: 'multiplos-funis',
        title: 'Funil de Vendas',
        type: 'item',
        icon: 'dashboard',
        url: '/mfe/multiple-funnels',
        menuPai: 'funis',
        exactMatch: true,
        companySystemModuleItemId: 135
    },
    {
        id: 'analise',
        title: 'Análise 360°',
        type: 'item',
        icon: 'donut_large',
        url: '#',
        menuPai: 'analise',
        companySystemModuleItemId: 8
    },
    {
        id: 'agenda',
        title: 'Agenda',
        type: 'item',
        icon: 'today',
        url: '/a2w/gestor/agenda',
        menuPai: 'agenda',
        companySystemModuleItemId: 2
    },

    { 
        id: 'atividades-pai',
        title: 'Atividades',
        type: 'collapsable',
        icon: 'playlist_add_check',
        children: [
            {
                id: 'resumo-atividades',
                title: 'Resumo',
                type: 'collapsable',
                icon: '',
                children: [
                    {
                        id: 'atividades-graficos',
                        title: 'Gráficos',
                        type: 'item',
                        icon: '',
                        url: '/a2w/gestor/paineis/atividades-graficos',
                        menuPai: 'atividades',
                        companySystemModuleItemId: 51
                    },
                    {
                        id: 'cobertura-e-positivacao',
                        title: 'Cobertura e Positivação',
                        type: 'item',
                        icon: '',
                        url: '/a2w/gestor/paineis/cobertura-e-positivacao',
                        menuPai: 'atividades',
                        companySystemModuleItemId: 4
                    },
                    {
                        id: 'atividades-mapas',
                        title: 'Mapas Estratégicos',                        
                        type: 'item',
                        icon: '',
                        url: '/a2w/gestor/atividades-mapas',
                        menuPai: 'atividades',
                        companySystemModuleItemId: 120
                    }
                ],
                menuPai: 'atividades',
                companySystemModuleItemId: 0
            },
            {
                id: 'novo-atividades',
                title: 'Nova Atividade',
                type: 'item',
                icon: '',
                url: '/a2w/gestor/atividades/new',
                menuPai: 'atividades',
                exactMatch: true,
                companySystemModuleItemId: 17 
            },
            {
                id: 'todas-atividades',
                title: 'Exibir Atividades',
                type: 'item',
                icon: '',
                url: '/a2w/gestor/atividades',
                menuPai: 'atividades',
                exactMatch: true,
                companySystemModuleItemId: 5
            },
            {
                id: 'automacao-pai',
                title: 'Automação',
                type: 'collapsable',
                icon: '',
                children: [
                    {
                        id: 'realizacao-atividades',
                        title: 'Executar em Massa',
                        type: 'item',
                        icon: '',
                        url: '/a2w/gestor/realizacao',
                        menuPai: 'atividades',
                        companySystemModuleItemId: 95
                    },
                    {
                        id: 'definicoes-atividades',
                        title: 'Criar Regras',
                        type: 'item',
                        icon: '',
                        url: '/a2w/gestor/definicoes',
                        menuPai: 'atividades',
                        companySystemModuleItemId: 94
                    },
                ],
                menuPai: 'atividades',
                companySystemModuleItemId: 0
            },
            {
                id: 'previsao-safra',
                title: 'Geração de Demandas',
                type: 'item',
                icon: '',
                url: '/a2w/gestor/previsao-safras',
                menuPai: 'atividades',
                companySystemModuleItemId: 6
            },
            {
                id: 'relatorios-atividades',
                title: 'Relatórios',
                type: 'collapsable',
                icon: '',
                children: [
                    {
                        id: 'fechamento-prod',
                        title: 'Fechamento de Produção',
                        type: 'item',
                        icon: '',
                        url: '/a2w/gestor/paineis/fechamento-producao',
                        menuPai: 'atividades',
                        companySystemModuleItemId: 97
                    },
                    {
                        id: 'relatorio-atividades-formulario',
                        title: 'Formulários',
                        type: 'item',
                        icon: '',
                        url: '/a2w/gestor/paineis/formularios-atividade',
                        menuPai: 'atividades',
                        companySystemModuleItemId: 124
                    },
                ],
                menuPai: 'atividades',
                companySystemModuleItemId: 0
            },
            {
                id: 'atividades-configuracoes',
                title: 'Configurações',
                type: 'collapsable',
                icon: '',
                children: [
                    {
                        id: 'motivo-atividade',
                        title: 'Motivos',
                        type: 'item',
                        icon: '',
                        url: '/a2w/supervisor/cadastros/motivo-atividade',
                        menuPai: 'atividades',
                        companySystemModuleItemId: 106
                    },
                    {
                        id: 'objetivo-atividade',
                        title: 'Objetivos',
                        type: 'item',
                        icon: '',
                        url: '/a2w/supervisor/cadastros/objetivo-atividade',
                        menuPai: 'atividades',
                        companySystemModuleItemId: 33
                    },
                    {
                        id: 'rodape-atividade',
                        title: 'Texto Rodapé',
                        type: 'item',
                        icon: '',
                        url: '/a2w/supervisor/cadastros/rodape-atividade',
                        menuPai: 'atividades',
                        companySystemModuleItemId: 126
                    },
                    {
                        id: 'tipos-atividade',
                        title: 'Tipos',
                        type: 'item',
                        icon: '',
                        url: '/a2w/supervisor/cadastros/tipo-atividade',
                        menuPai: 'atividades',
                        companySystemModuleItemId: 48
                    },
                ],
                menuPai: 'atividades',
                companySystemModuleItemId: 0
            },
        ],
        menuPai: 'atividades',
        companySystemModuleItemId: 0
    },

    { 
        id: 'negociacoes-pai',
        title: 'Negociações',
        type: 'collapsable',
        icon: 'monetization_on',
        children: [
            {
                id: 'resumo-negociacoes',
                title: 'Resumo',
                type: 'collapsable',
                icon: '',
                children: [
                    {
                        id: 'painel-gestor',
                        title: 'Faturamento',
                        type: 'item',
                        icon: '',
                        url: '/a2w/gestor/vendas/resumo/faturamento',
                        menuPai: 'negociacoes',
                        companySystemModuleItemId: 25
                    },
                    {
                        id: 'pedidos-graficos',
                        title: 'Pedidos',
                        icon: '',
                        type: 'item',
                        url: '/a2w/gestor/paineis/pedidos-graficos',
                        menuPai: 'negociacoes',
                        companySystemModuleItemId: 54
                    },
                    {
                        id: 'funil-vendas',
                        title: 'Pedidos por Funil',
                        type: 'item',
                        icon: '',
                        url: '/a2w/gestor/paineis/funil-vendas',
                        menuPai: 'negociacoes',
                        companySystemModuleItemId: 91
                    },
                    {
                        id: 'mapas-pedidos',
                        title: 'Mapas Estratégicos',
                        type: 'item',
                        icon: '',
                        url: '/a2w/gestor/mapas',
                        menuPai: 'negociacoes',
                        companySystemModuleItemId: 3
                    },
                ],
                menuPai: 'negociacoes',
                companySystemModuleItemId: 0
            },
            {
                id: 'gestao-entregas',
                title: 'Gestão de Entregas',
                type: 'item',
                icon: '',
                url: '/mfe/plugins',
                menuPai: 'negociacoes',
                exactMatch: true,
                companySystemModuleItemId: 132
            },
            {
                id: 'novo-pedidos',
                title: 'Novo Pedido',
                type: 'item',
                icon: '',
                url: '/a2w/gestor/vendas/pedidos/new',
                menuPai: 'negociacoes',
                exactMatch: true,
                companySystemModuleItemId: 12                
            },
            {
                id: 'todos-pedidos',
                title: 'Exibir Pedidos',
                type: 'item',
                icon: '',
                url: '/a2w/gestor/vendas/pedidos',
                menuPai: 'negociacoes',
                exactMatch: true,
                companySystemModuleItemId: 13
            },
            {
                id: 'saldos-e-precos',
                title: 'Saldos e Preços',
                type: 'item',
                icon: '',
                url: '/a2w/gestor/vendas/saldos-e-precos',
                menuPai: 'negociacoes',
                companySystemModuleItemId: 70
            },
            {
                id: 'notas-fiscais',
                title: 'Exibir Notas Fiscais',
                type: 'item',
                icon: '',
                url: '/a2w/gestor/vendas/notas-fiscais',
                menuPai: 'negociacoes',
                companySystemModuleItemId: 14
            },
             {
                id: 'aprovacoes',
                title: 'Aprova Pedidos',
                type: 'item',
                icon: '',
                url: '/a2w/gestor/vendas/aprovacoes-pedidos',
                menuPai: 'negociacoes',
                companySystemModuleItemId: 100
            },
            {
                id: 'estoque-canal',
                title: 'Estoque de Canal',
                type: 'item',
                icon: '',
                url: '/a2w/gestor/vendas/estoque-canal',
                menuPai: 'negociacoes',
                companySystemModuleItemId: 115
            },
            {
                id: 'ofertas',
                title: 'Oferta Estruturada',
                type: 'item',
                icon: '',
                url: '/a2w/gestor/vendas/ofertas',
                menuPai: 'negociacoes',
                companySystemModuleItemId: 103
            },           
            /* { //VAI EXISTIR FUTURAMENTE
                id: 'relatorios-negociacoes',
                title: 'Relatórios',
                type: 'collapsable',
                icon: '',
                children: [
                ],
                menuPai: 'negociacoes',
                companySystemModuleItemId: 0
            }, */
            {
                id: 'configuracoes-negociacoes',
                title: 'Configurações',
                type: 'collapsable',
                icon: '',
                children: [
                    {
                        id: 'campanha',
                        title: 'Campanhas',
                        type: 'item',
                        icon: '',
                        url: '/a2w/supervisor/cadastros/campanha',
                        menuPai: 'negociacoes',
                        companySystemModuleItemId: 123
                    },
                    {
                        id: 'casas-decimais',
                        title: 'Casas Decimais',
                        type: 'item',
                        icon: '',
                        url: '/a2w/supervisor/cadastros/casas-decimais',
                        menuPai: 'negociacoes',
                        companySystemModuleItemId: 128
                    },
                    {
                        id: 'prazos-vencimentos',
                        title: 'Condições de Pagamentos',
                        type: 'item',
                        icon: '',
                        url: '/a2w/supervisor/cadastros/prazo-vencimento',
                        menuPai: 'negociacoes',
                        companySystemModuleItemId: 40
                    },
                    {
                        id: 'formas-pagto',
                        title: 'Formas de Pagamento',
                        type: 'item',
                        icon: '',
                        url: '/a2w/supervisor/cadastros/forma-pagto',
                        menuPai: 'negociacoes',
                        companySystemModuleItemId: 30
                    },
                    {
                        id: 'moedas-cotacoes',
                        title: 'Moedas e Cotações',
                        type: 'item',
                        icon: '',
                        url: '/a2w/supervisor/cadastros/moedas-cotacoes',
                        menuPai: 'negociacoes',
                        companySystemModuleItemId: 72
                    },
                    {
                        id: 'motivos-reprogramacao',
                        title: 'Motivos',
                        type: 'item',
                        icon: '',
                        url: '/mfe/reasons',
                        menuPai: 'negociacoes',
                        // TODO: 133 é placeholder — confirmar o companySystemModuleItemId real antes de ir pra produção.
                        companySystemModuleItemId: 133
                    },
                    {
                        id: 'rodape-pedido',
                        title: 'Textos Rodapé',
                        type: 'item',
                        icon: '',
                        url: '/a2w/supervisor/cadastros/rodape-pedido',
                        menuPai: 'negociacoes',
                        companySystemModuleItemId: 64
                    },
                    {
                        id: 'tipo-atendimento',
                        title: 'Tipos de Atendimentos',
                        type: 'item',
                        icon: '',
                        url: '/a2w/supervisor/cadastros/tipo-atendimento',
                        menuPai: 'negociacoes',
                        companySystemModuleItemId: 90
                    },
                    {
                        id: 'tipos-negociacao',
                        title: 'Tipos de Negociações',
                        type: 'item',
                        icon: '',
                        url: '/a2w/supervisor/cadastros/tipo-negociacao',
                        menuPai: 'negociacoes',
                        companySystemModuleItemId: 49
                    },
                    {
                        id: 'tipo-frete-nota',
                        title: 'Tipos de Fretes',
                        type: 'item',
                        icon: '',
                        url: '/a2w/supervisor/cadastros/tipo-frete-nota',
                        menuPai: 'negociacoes',
                        companySystemModuleItemId: 47
                    },
                    {
                        id: 'tipo-utilizacao',
                        title: 'Tipos de Utilizações',
                        type: 'item',
                        icon: '',
                        url: '/a2w/supervisor/cadastros/tipo-utilizacao',
                        menuPai: 'negociacoes',
                        companySystemModuleItemId: 71
                    },
                     {
                        id: 'transportadoras',
                        title: 'Transportadoras',
                        type: 'item',
                        icon: '',
                        url: '/mfe/carriers',
                        menuPai: 'negociacoes',
                        // TODO: 134 é placeholder — confirmar o companySystemModuleItemId real antes de ir pra produção.
                        companySystemModuleItemId: 134
                    },
                    {
                        id: 'regras-de-aprovacoes',
                        title: 'Regras de Aprovação',
                        type: 'item',
                        icon: '',
                        url: '/a2w/supervisor/cadastros/regras-de-aprovacao',
                        menuPai: 'negociacoes',
                        companySystemModuleItemId: 101
                    },
                    {
                        id: 'regras-de-comissao',
                        title: 'Regras de Comissão',
                        type: 'item',
                        icon: '',
                        url: '/a2w/supervisor/cadastros/regras-de-comissao',
                        menuPai: 'negociacoes',
                        companySystemModuleItemId: 121
                    },
                    {
                        id: 'tabela-fretes',
                        title: 'Frete Flex',
                        type: 'item',
                        icon: '',
                        url: '/a2w/supervisor/cadastros/tabela-fretes',
                        menuPai: 'negociacoes',
                        companySystemModuleItemId: 75
                    },
                    {
                        id: 'manejos',
                        title: 'Manejos para Oferta',
                        type: 'item',
                        icon: '',
                        url: '/a2w/supervisor/cadastros/manejo',
                        menuPai: 'negociacoes',
                        companySystemModuleItemId: 98
                    },
                    {
                        id: 'semaforo',
                        title: 'Semáforo',
                        type: 'item',
                        icon: '',
                        url: '/a2w/supervisor/cadastros/semaforo',
                        menuPai: 'negociacoes',
                        companySystemModuleItemId: 93
                    },
                ],
                menuPai: 'negociacoes',
                companySystemModuleItemId: 0
            }
        ],
        menuPai: 'negociacoes',
        companySystemModuleItemId: 0
    },

    { 
        id: 'planejamento-pai',
        title: 'Planejamento Comercial',
        type: 'collapsable',
        icon: 'assessment',
        children: [
            {
                id: 'resumo-planejamento',
                title: 'Resumo',
                type: 'collapsable',
                icon: '',
                children: [
                    {
                        id: 'graficos-metas',
                        title: 'Metas',
                        type: 'item',
                        icon: '',
                        url: '/a2w/gestor/paineis/graficos-metas',
                        menuPai: 'planejamento',
                        companySystemModuleItemId: 53
                    },
                    {
                        id: 'relatorios-personalizados-consultas',
                        title: 'Relatório de Metas',
                        type: 'item',
                        icon: '',
                        url: '/a2w/gestor/relatorios',
                        menuPai: 'planejamento',
                        companySystemModuleItemId: 24
                    },
                ],
                menuPai: 'planejamento',
                companySystemModuleItemId: 0
            },
            {
                id: 'metas',
                title: 'Definições de Metas',
                type: 'item',
                icon: '',
                url: '/a2w/gestor/definicoes-comerciais/metas',
                menuPai: 'planejamento',
                companySystemModuleItemId: 9
            },
            {
                id: 'pacotes-tecnologicos',
                title: 'Pacotes Tecnológicos',
                type: 'item',
                icon: '',
                url: '/a2w/gestor/pacotes-tecnologicos',
                menuPai: 'planejamento',
                companySystemModuleItemId: 34
            },
            {
                id: 'variaveis-genericas',
                title: 'Variáveis de Configuração',
                type: 'item',
                icon: '',
                url: '/a2w/supervisor/cadastros/variaveis-genericas',
                menuPai: 'planejamento',
                companySystemModuleItemId: 108
            }
        ],
        menuPai: 'planejamento',
        companySystemModuleItemId: 0
    },

    { 
        id: 'parceiros-pai',
        title: 'Parceiros de Negócios',
        type: 'collapsable',
        icon: 'groups',
        children: [
            {
                id: 'resumo-parceiro-negocio',
                title: 'Resumo',
                type: 'collapsable',
                icon: '',
                children: [
                    {
                        id: 'visao-clientes',
                        title: 'Visão de Clientes',
                        type: 'item',
                        icon: '',
                        url: '/a2w/gestor/paineis/visao-clientes',
                        menuPai: 'resumo-parceiro-negocio',
                        companySystemModuleItemId: 122
                    }
                ],
                menuPai: 'parceiros',
                companySystemModuleItemId: 0
            },
            {
                id: 'novo-cliente',
                title: 'Novo Cliente',
                type: 'item',
                icon: '',
                url: '/a2w/supervisor/cadastros/parceiros-negocios/clientes-leads/new',
                menuPai: 'parceiros',
                exactMatch: true,
                companySystemModuleItemId: 74
            },
            {
                id: 'todos-clientes',
                title: 'Exibir Clientes',
                type: 'item',
                icon: '',
                url: '/a2w/supervisor/cadastros/parceiros-negocios/clientes-leads',
                menuPai: 'parceiros',
                exactMatch: true,
                companySystemModuleItemId: 76,
            },
            {
                id: 'clientes',
                title: 'Clientes - Antigo',
                type: 'item',
                icon: '',
                url: '/a2w/supervisor/cadastros/parceiros-negocios/cliente',
                menuPai: 'parceiros',
                companySystemModuleItemId: 35
            },
            {
                id: 'vendedores',
                title: 'Consultores/ Colaboradores',
                type: 'item',
                icon: '',
                url: '/a2w/supervisor/cadastros/parceiros-negocios/vendedor',
                menuPai: 'parceiros',
                companySystemModuleItemId: 37
            },
            {
                id: 'perfil',
                title: 'Configurações',
                type: 'collapsable',
                icon: '',
                children: [
                    {
                        id: 'caracteristica',
                        title: 'Características',
                        type: 'item',
                        icon: '',
                        url: '/a2w/supervisor/cadastros/parceiros-negocios/caracteristica',
                        menuPai: 'parceiros',
                        companySystemModuleItemId: 83
                    },
                    {
                        id: 'classificacao',
                        title: 'Classificações',
                        type: 'item',
                        icon: '',
                        url: '/a2w/supervisor/cadastros/parceiros-negocios/classificacao',
                        menuPai: 'parceiros',
                        companySystemModuleItemId: 84
                    },
                    {
                        id: 'financeiro-perfil',
                        title: 'Financeiro',
                        type: 'item',
                        icon: '',
                        url: '/a2w/supervisor/cadastros/parceiros-negocios/financeiro',
                        menuPai: 'parceiros',
                        companySystemModuleItemId: 81
                    },
                    {
                        id: 'hobbie',
                        title: 'Hobbies',
                        type: 'item',
                        icon: '',
                        url: '/a2w/supervisor/cadastros/parceiros-negocios/hobbie',
                        menuPai: 'parceiros',
                        companySystemModuleItemId: 85
                    },
                    {
                        id: 'origem',
                        title: 'Origem',
                        type: 'item',
                        icon: '',
                        url: '/a2w/supervisor/cadastros/parceiros-negocios/origem',
                        menuPai: 'parceiros',
                        companySystemModuleItemId: 80
                    },
                    {
                        id: 'regiao',
                        title: 'Regiões',
                        type: 'item',
                        icon: '',
                        url: '/a2w/supervisor/cadastros/parceiros-negocios/regiao',
                        menuPai: 'parceiros',
                        companySystemModuleItemId: 82
                    },
                    {
                        id: 'segmento',
                        title: 'Segmentos',
                        type: 'item',
                        icon: '',
                        url: '/a2w/supervisor/cadastros/parceiros-negocios/segmento',
                        menuPai: 'parceiros',
                        companySystemModuleItemId: 86
                    },
                    {
                        id: 'status',
                        title: 'Status',
                        type: 'item',
                        icon: '',
                        url: '/a2w/supervisor/cadastros/parceiros-negocios/status',
                        menuPai: 'parceiros',
                        companySystemModuleItemId: 79
                    },
                    {
                        id: 'tipos-enderecos',
                        title: 'Tipos de Endereços',
                        type: 'item',
                        icon: '',
                        url: '/a2w/supervisor/cadastros/parceiros-negocios/tipos-enderecos',
                        menuPai: 'parceiros',
                        companySystemModuleItemId: 105
                    },
                    {
                        id: 'grupo-consultores',
                        title: 'Grupo de Consultores',
                        type: 'item',
                        icon: '',
                        url: '/a2w/supervisor/cadastros/parceiros-negocios/grupo-consultores',
                        menuPai: 'parceiros',
                        companySystemModuleItemId: 127
                    },
                ],
                menuPai: 'parceiros',
                companySystemModuleItemId: 0
            },
        ],
        menuPai: 'parceiros',
        companySystemModuleItemId: 0
    },

    { 
        id: 'produtos-pai',
        title: 'Produtos',
        type: 'collapsable',
        icon: 'add_shopping_cart',
        children: [
            {
                id: 'novo-produtos',
                title: 'Novo Produto',
                type: 'item',
                icon: '',
                url: '/a2w/supervisor/cadastros/produto/new',
                menuPai: 'produtos',
                exactMatch: true,
                companySystemModuleItemId: 45
            },
            {
                id: 'todos-produtos',
                title: 'Exibir Produtos',
                type: 'item',
                icon: '',
                url: '/a2w/supervisor/cadastros/produto',
                menuPai: 'produtos',
                exactMatch: true,
                companySystemModuleItemId: 41
            },
            {
                id: 'configuracoes-produtos',
                title: 'Configurações',
                type: 'collapsable',
                icon: '',
                children: [
                    {
                        id: 'embalagens',
                        title: 'Embalagens',
                        type: 'item',
                        icon: '',
                        url: '/a2w/supervisor/cadastros/embalagens',
                        menuPai: 'produtos',
                        companySystemModuleItemId: 28
                    },
                    {
                        id: 'grupo-produtos',
                        title: 'Grupos de Produtos',
                        type: 'item',
                        icon: '',
                        url: '/a2w/supervisor/cadastros/grupo-produto',
                        menuPai: 'produtos',
                        companySystemModuleItemId: 31
                    },
                    {
                        id: 'listas-precos',
                        title: 'Listas de Preços',
                        type: 'item',
                        icon: '',
                        url: '/a2w/supervisor/cadastros/lista-precos-custos/preco',
                        menuPai: 'produtos',
                        companySystemModuleItemId: 32
                    },
                    {
                        id: 'lista-precos-custos',
                        title: 'Listas de Custos',
                        type: 'item',
                        icon: '',
                        url: '/a2w/supervisor/cadastros/lista-precos-custos/custo',
                        menuPai: 'produtos',
                        companySystemModuleItemId: 119
                    },
                    {
                        id: 'marca',
                        title: 'Marcas',
                        type: 'item',
                        icon: '',
                        url: '/a2w/supervisor/cadastros/marca',
                        menuPai: 'produtos',
                        companySystemModuleItemId: 89
                    },
                    {
                        id: 'produtos-substitutos',
                        title: 'Produtos Substitutos',
                        type: 'item',
                        icon: '',
                        url: '/a2w/gestor/produtos-substitutos',
                        menuPai: 'produtos',
                        companySystemModuleItemId: 11
                    },
                    {
                        id: 'unidades-medidas',
                        title: 'Unidades de Medida',
                        type: 'item',
                        icon: '',
                        url: '/a2w/supervisor/cadastros/unidade',
                        menuPai: 'produtos',
                        companySystemModuleItemId: 50
                    }
                ],
                menuPai: 'produtos',
                companySystemModuleItemId: 0
            },
        ],
        menuPai: 'produtos',
        companySystemModuleItemId: 0
    },

    { 
        id: 'financeiro-pai',
        title: 'Financeiro',
        type: 'collapsable',
        icon: 'attach_money',
        children: [
            /* { //FUTURAMENTE
                id: 'resumo-financeiro',
                title: 'Resumo',
                type: 'collapsable',
                icon: '',
                children: [
                    {
                        id: 'graficos-financeiro',
                        title: 'Gráfico',
                        type: 'item',
                        icon: '',
                        url: '#',
                        menuPai: 'financeiro',
                        companySystemModuleItemId: 15
                    },
                ],
                menuPai: 'financeiro',
                companySystemModuleItemId: 0
            }, */
            {
                id: 'limite-credito',
                title: 'Limite de Crédito',
                type: 'item',
                icon: '',
                url: '/a2w/gestor/financeiro/limite-credito',
                menuPai: 'financeiro',
                companySystemModuleItemId: 16
            },
            {
                id: 'recebimentos',
                title: 'Títulos a Receber',
                type: 'item',
                icon: '',
                url: '/a2w/gestor/financeiro/recebimentos',
                menuPai: 'financeiro',
                companySystemModuleItemId: 18
            }
        ],
        menuPai: 'financeiro',
        companySystemModuleItemId: 0
    },

    { 
        id: 'despesas-pai',
        title: 'Despesas de Viagens',
        type: 'collapsable',
        icon: 'work_outline',
        children: [
            {
                id: 'resumo-despesas',
                title: 'Resumo',
                type: 'collapsable',
                icon: '',
                children: [
                    {
                        id: 'graficos-despesas',
                        title: 'Gráficos',
                        type: 'item',
                        icon: '',
                        url: '/a2w/gestor/paineis/relatorio-despesas',
                        menuPai: 'despesas',
                        companySystemModuleItemId: 52
                    },
                ],
                menuPai: 'despesas',
                companySystemModuleItemId: 0
            },
            {
                id: 'aprovacaoes-despesas',
                title: 'Adiantamentos',
                type: 'item',
                icon: '',
                url: '/a2w/gestor/aprovacoes',
                menuPai: 'despesas',
                companySystemModuleItemId: 10
            },
            {
                id: 'niveis-aprovacoes',
                title: 'Níveis de Aprovação',
                type: 'item',
                icon: '',
                url: '/a2w/gestor/niveis-aprovacoes',
                menuPai: 'despesas',
                companySystemModuleItemId: 96
            },
            {
                id: 'despesas-extratos',
                title: 'Extratos',
                type: 'item',
                icon: '',
                url: '/a2w/gestor/despesas/saldos-extratos',
                menuPai: 'despesas',
                companySystemModuleItemId: 65
            },
            {
                id: 'relatorio-despesa-viagem',
                title: 'Exibir Relatórios',
                type: 'item',
                icon: '',
                url: '/a2w/gestor/relatorio-despesas-viagens',
                menuPai: 'despesas',
                companySystemModuleItemId: 7
            },
            {
                id: 'a2w-card',
                title: 'A2W Card',
                type: 'collapsable',
                icon: '',
                children: [                    
                    {
                        id: 'cartoes-usuario',
                        title: 'Cartões por Usuário',
                        type: 'item',
                        icon: '',
                        url: '/a2w/gestor/a2w-card/cartoes-por-usuario',
                        menuPai: 'despesas',
                        companySystemModuleItemId: 110
                    },
                    {
                        id: 'gestao-cartoes',
                        title: 'Gestão de Cartões',
                        type: 'item',
                        icon: '',
                        url: '/a2w/gestor/a2w-manager-card/gestao-cartoes',
                        menuPai: 'despesas',
                        companySystemModuleItemId: 116
                    },
                    {
                        id: 'rendimento-pay',
                        title: 'Rendimento Pay',
                        type: 'item',
                        icon: '',
                        url: '&&',
                        menuPai: 'despesas',
                        companySystemModuleItemId: 104
                    },
                ],
                menuPai: 'despesas',
                companySystemModuleItemId: 0
            },
            {
                id: 'relatorios-despesas',
                title: 'Configurações',
                type: 'collapsable',
                icon: '',
                children: [
                    {
                        id: 'projetos',
                        title: 'Projetos',
                        type: 'item',
                        icon: '',
                        url: '/a2w/supervisor/cadastros/relatorio-despesas/projetos',
                        menuPai: 'despesas',
                        companySystemModuleItemId: 107
                    },
                    {
                        id: 'regras-limite-despesas-viagens',
                        title: 'Regras e Limites',
                        type: 'item',
                        icon: '',
                        url: '/a2w/supervisor/cadastros/relatorio-despesas/regras-limite-despesas-viagens',
                        menuPai: 'despesas',
                        companySystemModuleItemId: 44
                    },
                    {
                        id: 'tipos-despesas',
                        title: 'Tipos de Despesas',
                        type: 'item',
                        icon: '',
                        url: '/a2w/supervisor/cadastros/relatorio-despesas/tipos-despesas',
                        menuPai: 'despesas',
                        companySystemModuleItemId: 42
                    },
                    {
                        id: 'tipos-lancamentos',
                        title: 'Tipos de Lançamentos',
                        type: 'item',
                        icon: '',
                        url: '/a2w/supervisor/cadastros/relatorio-despesas/tipos-lancamentos',
                        menuPai: 'despesas',
                        companySystemModuleItemId: 78
                    },
                    {
                        id: 'tipos-pagamentos',
                        title: 'Tipos de Pagamentos',
                        type: 'item',
                        icon: '',
                        url: '/a2w/supervisor/cadastros/relatorio-despesas/tipos-pagamentos',
                        menuPai: 'despesas',
                        companySystemModuleItemId: 43
                    },
                    {
                        id: 'veiculos',
                        title: 'Veículos',
                        type: 'item',
                        icon: '',
                        url: '#',//'/a2w/supervisor/cadastros/relatorio-despesas/veiculos',
                        menuPai: 'despesas',
                        companySystemModuleItemId: 77
                    }
                ],
                menuPai: 'despesas',
                companySystemModuleItemId: 0
            },
        ],
        menuPai: 'despesas',
        companySystemModuleItemId: 0
    },

    { 
        id: 'permissoes-pai',
        title: 'Restrições e Permissões',
        type: 'collapsable',
        icon: 'lock',
        children: [
            {
                id: 'resumo-permissoes',
                title: 'Resumo',
                type: 'collapsable',
                icon: '',
                children: [
                    {
                        id: 'acesso',
                        title: 'Acessos',
                        type: 'item',
                        icon: '',
                        url: '/a2w/supervisor/restricoes-permissoes/acessos',
                        menuPai: 'permissoes',
                        companySystemModuleItemId: 68
                    },
                ],
                menuPai: 'permissoes',
                companySystemModuleItemId: 0
            },
            {
                id: 'novo-usuario',
                title: 'Novo Usuário',
                type: 'item',
                icon: '',
                url: '/a2w/supervisor/restricoes-permissoes/usuario/new',
                menuPai: 'permissoes',
                exactMatch: true,
                companySystemModuleItemId: 36
            },
            {
                id: 'usuario',
                title: 'Exibir Usuários',
                type: 'item',
                icon: '',
                url: '/a2w/supervisor/restricoes-permissoes/usuario',
                menuPai: 'permissoes',
                exactMatch: true,
                companySystemModuleItemId: 59
            },
            {
                id: 'grupo-usuario',
                title: 'Grupos de Usuários',
                type: 'item',
                icon: '',
                url: '/a2w/supervisor/restricoes-permissoes/grupo-usuarios',
                menuPai: 'permissoes',
                companySystemModuleItemId: 58
            },
            {
                id: 'modulo',
                title: 'Módulos',
                type: 'item',
                icon: '',
                url: '/a2w/supervisor/restricoes-permissoes/modulos',
                menuPai: 'permissoes',
                companySystemModuleItemId: 114
            }
        ],
        menuPai: 'permissoes',
        companySystemModuleItemId: 0
    },

    { 
        id: 'parametro-pai',
        title: 'Parâmetros do Ambiente',
        type: 'collapsable',
        icon: 'toggle_off',
        children: [
            {
                id: 'alertas',
                title: 'Alertas',
                type: 'collapsable',
                icon: '',
                children: [
                    {
                        id: 'flags-notificacoes',
                        title: 'Notificações do Sistema',
                        type: 'item',
                        icon: '',
                        url: '/a2w/supervisor/configuracoes/flags-notificacoes',
                        menuPai: 'parametros',
                        companySystemModuleItemId: 112
                    },
                ],
                menuPai: 'parametros',
                companySystemModuleItemId: 0
            },
            {
                id: 'meus-apps',
                title: 'Meus Apps',
                type: 'collapsable',
                icon: '',
                children: [
                    {
                        id: 'app-armazenagem',
                        title: 'App Armazenagem',
                        type: 'item',
                        icon: '',
                        url: '/a2w/supervisor/configuracoes/personalizacao-apps/armazenagem',
                        menuPai: 'parametros',
                        companySystemModuleItemId: 99
                    },
                    {
                        id: 'app-consultor',
                        title: 'App Consultor',
                        type: 'collapsable',
                        icon: '',
                        children: [
                            {
                                id: 'definicao',
                                title: 'Cards',
                                type: 'item',
                                icon: '',
                                url: '/a2w/supervisor/cadastros/definicao',
                                menuPai: 'parametros',
                                companySystemModuleItemId: 87
                            },
                        ],
                        menuPai: 'parametros',
                        companySystemModuleItemId: 0
                    },                   
                    {
                        id: 'app-distribuidor',
                        title: 'App Distribuidor',
                        type: 'item',
                        icon: '',
                        url: '/a2w/supervisor/configuracoes/personalizacao-apps/distribuidor',
                        menuPai: 'parametros',
                        companySystemModuleItemId: 109
                    },
                ],
                menuPai: 'parametros',
                companySystemModuleItemId: 0
            },
            {
                id: 'empresas-pai',
                title: 'Empresas',
                type: 'collapsable',
                icon: '',
                children: [
                    {
                        id: 'empresas',
                        title: 'Empresas',
                        type: 'item',
                        icon: '',
                        url: '/a2w/supervisor/cadastros/empresa',
                        menuPai: 'parametros',
                        companySystemModuleItemId: 29
                    },
                    {
                        id: 'grupo-empresas',
                        title: 'Grupos de Empresas',
                        type: 'item',
                        icon: '',
                        url: '/a2w/supervisor/cadastros/grupo-empresa',
                        menuPai: 'parametros',
                        companySystemModuleItemId: 63
                    },
                ],
                menuPai: 'parametros',
                companySystemModuleItemId: 0
            },
            {
                id: 'culturas-pai',
                title: 'Culturas',
                type: 'collapsable',
                icon: '',
                children: [
                     {
                        id: 'culturas',
                        title: 'Culturas',
                        type: 'item',
                        icon: '',
                        url: '/a2w/supervisor/cadastros/culturas',
                        menuPai: 'parametros',
                        companySystemModuleItemId: 27
                    },
                    {
                        id: 'grupo-culturas',
                        title: 'Grupos de Culturas',
                        type: 'item',
                        icon: '',
                        url: '/a2w/supervisor/cadastros/grupo-cultura',
                        menuPai: 'parametros',
                        companySystemModuleItemId: 62
                    },
                ],
                menuPai: 'parametros',
                companySystemModuleItemId: 0
            },
            {
                id: 'safra',
                title: 'Safras',
                type: 'item',
                icon: '',
                url: '/a2w/supervisor/cadastros/safra',
                menuPai: 'parametros',
                companySystemModuleItemId: 46
            },
            {
                id: 'integracoes-pai',
                title: 'Integrações',
                type: 'collapsable',
                icon: '',
                children: [
                    {
                        id: 'integracoes',
                        title: 'Sincronizar com o ERP',
                        type: 'item',
                        icon: '',
                        url: '/a2w/supervisor/configuracoes/integracoes',
                        menuPai: 'parametros',
                        companySystemModuleItemId: 26
                    }, {
                        id: 'upload-de-planilhas',
                        title: 'Importação por Planilha',
                        type: 'item',
                        icon: '',
                        url: '/a2w/supervisor/configuracoes/upload-de-planilhas',
                        menuPai: 'parametros',
                        companySystemModuleItemId: 92
                    }, {
                        id: 'cadastro-key',
                        title: 'API Google Maps',
                        type: 'item',
                        icon: '',
                        url: '/a2w/supervisor/configuracoes/cadastro-key',
                        menuPai: 'parametros',
                        companySystemModuleItemId: 73
                    },
                    {
                        id: 'config-entraid',
                        title: 'Autenticação EntraID',
                        type: 'item',
                        icon: '',
                        url: '/a2w/supervisor/configuracoes/autenticacao-entraid',
                        menuPai: 'parametros',
                        companySystemModuleItemId: 117
                    },
                    {
                        id: 'zap-sign',
                        title: 'ZapSign',
                        type: 'item',
                        icon: '',
                        url: '/a2w/supervisor/configuracoes/zap-sign',
                        menuPai: 'parametros',
                        companySystemModuleItemId: 118
                    },
                ],
                menuPai: 'parametros',
                companySystemModuleItemId: 0
            },
            {
                id: 'regras-negocios',
                title: 'Regras de Negócios',
                type: 'item',
                icon: '',
                url: '/a2w/supervisor/configuracoes/regras-negocios',
                menuPai: 'parametros',
                companySystemModuleItemId: 69
            },
        ],
        menuPai: 'parametros',
        companySystemModuleItemId: 0
    },

    { 
        id: 'central-pai',
        title: 'Central do Cliente',
        type: 'collapsable',
        icon: 'headset_mic',
        children: [
            {
                id: 'atendimento',
                title: 'Precisa de Ajuda?',
                type: 'item',
                icon: '',
                url: '&&',
                menuPai: 'central',
                companySystemModuleItemId: 56
            },
            {
                id: 'termos-condicoes',
                title: 'Termos e Condições',
                type: 'collapsable',
                icon: '',
                children: [
                    {
                        id: 'documento',
                        title: 'Ativação da Conta',
                        type: 'item',
                        icon: '',
                        url: '/a2w/assinaturas/termos-privacidade',
                        menuPai: 'central',
                        companySystemModuleItemId: 39
                    },
                    {
                        id: 'log',
                        title: 'Assinaturas',
                        type: 'item',
                        icon: '',
                        url: '/a2w/assinaturas/logs',
                        menuPai: 'central',
                        companySystemModuleItemId: 38
                    },
                    {
                        id: 'politica',
                        title: 'Política de Privacidade',
                        type: 'item',
                        icon: '',
                        url: '&&',
                        menuPai: 'central',
                        companySystemModuleItemId: 60
                    },
                    {
                        id: 'termos-uso',
                        title: 'Termos de Uso',
                        type: 'item',
                        icon: '',
                        url: '&&',
                        menuPai: 'central',
                        companySystemModuleItemId: 61
                    },
                ],
                menuPai: 'central',
                companySystemModuleItemId: 0
            },
        ],
        menuPai: 'central',
        companySystemModuleItemId: 0
    },
];

/**/
/**/
/** ATENCAO - ULTIMO ID UTILIZADO 128 - FAVOR ATUALIZAR ESSA LINHA APOS CRIAR UM NOVO MENU**/
/***  ATUALIZAR NAVIGATION navigation.ts E PERMISSION MODULE permission-modules.service.ts **/
/**/
/**/